export default {
  container: {
    padding: '20px 0'
  },
  btn: {
    margin: '0 4px 0 0'
  }
}
